module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-vibrate-75dff6d1.svg";